import {twMerge} from '@sdox/utils'

import type {ComponentProps} from 'react'

export const SmallPrint = ({children, className, ...restProps}: ComponentProps<'div'>) => (
  <div
    className={twMerge('text-xs text-gray-500', className)}
    {...restProps}
  >
    {children}
  </div>
)
